import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { toRoman } from 'helpers'
import { upgradeAvailability } from 'helpers/stronghold'
import { COMMAND_CENTER_TITLE } from 'helpers/i18n.jsx'

import UpgradeIcon from 'components/UpgradeIcon/UpgradeIcon.jsx'

import { COMMAND_CENTER_TOOLTIP_ID } from 'constants'

import styles from './CommandCenter.scss'

export class CommandCenter extends React.Component {

    static propTypes = {
        level: PropTypes.number,
        isUpgradeAvailable: PropTypes.bool.isRequired,
        isOwn: PropTypes.bool.isRequired,

        handleClick: PropTypes.func,
        handleHover: PropTypes.func,
    }

    render() {

        const upgradeAvailable = this.props.isUpgradeAvailable ? (
            <div className={styles.upgradeAvailable}>
                <UpgradeIcon/>
            </div>
        ) : null

        const imageClassName = classNames(styles.image, styles[`image__${this.props.level}`])

        const className = classNames(styles.base, {
            [styles.base__foreign]: !this.props.isOwn,
        })

        return (
            <div
                className={className}
                onClick={this.props.handleClick}
                onMouseEnter={this.props.handleHover}
                data-tip
                data-for={COMMAND_CENTER_TOOLTIP_ID}
            >
                <p className={styles.title}>
                    <span className={styles.level}>
                        {toRoman(this.props.level)}
                        <span className={styles.levelShadow}>{toRoman(this.props.level)}</span>
                    </span>
                    {COMMAND_CENTER_TITLE}
                </p>
                {upgradeAvailable}
                <div className={imageClassName}></div>
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        isUpgradeAvailable: upgradeAvailability(state),
    }
}

export default connect(mapStateToProps, null)(CommandCenter)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/CommandCenter/CommandCenter.jsx